/**
 * Convert object to url params string
 * 
 * @param {object} obj 
 * @returns {string}
 */
 export const objToUrlParams = (obj) => {
  let str = '';

  for (var key in obj) {
    const value = obj[key];
    const name = key;

    if (str != '') str += '&';

    if (Array.isArray(value)) {
      value.map(v => str += `${name}[]=${encodeURIComponent(v)}`);
    } else {
      str += `${name}=${encodeURIComponent(value)}`;
    }
  }

  return str;
}

/**
 * Check if given element is in view.
 * 
 * @param {HTMLElement} ele
 * @param {function} cb
 * @param {object} opts
 * @returns {null}
 */
export const observeWhenInView = (ele, cb, opts = {}) => {
  let prevIsIntersecting = false;

  const unobserve = () => {
    observer.unobserve(ele);
  }

  const handleIntersect = (entries) => {
    const [{ isIntersecting }] = entries;
    
    if (prevIsIntersecting != isIntersecting) {
      cb(isIntersecting, unobserve);
      prevIsIntersecting = isIntersecting;
    }
  }
  
  let observer = new IntersectionObserver(handleIntersect, {rootMargin: '-10% 0% -10% 0%', ...opts});
  observer.observe(ele);
}

/**
 * Debounce function
 * 
 * @param {function} callback
 * @param {number} wait
 * @returns {function}
 */
export const debounce = (callback, wait) => {
  let timeout;

  return (...args) => {
    window.clearTimeout(timeout);

    timeout = window.setTimeout(() => {
      callback.apply(null, args);
    }, wait);
  }
}

/**
 * Load third party scripts
 * 
 * @param {string} src
 * @returns {function}
 */
export const loadScript = (() => {
  let loaded = [];
  let loading = [];
  let onLoadCb = {};

  const onLoad = (src) => {
    loaded.push(src);
    loading = loading.filter(s => s != src);
    fufillCallbacks(src);
  }

  const fufillCallbacks = (src) => {
    onLoadCb[src] && onLoadCb[src].forEach(cb => cb());
    delete onLoadCb[src];
  }

  const buildScript = (src) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => onLoad(src);
    document.body.appendChild(script);
  }

  return (src, opts = {}) => {
    if (loaded.includes(src)) 
      return opts.onLoad && opts.onLoad();

    onLoadCb[src] = onLoadCb[src] || [];
    onLoadCb[src].push(opts.onLoad);

    if (!loading.includes(src)) {
      loading.push(src);
      buildScript(src);
    }
  }
})();

/**
 * Infinite scroll
 * 
 * @param {HTMLElement} ele
 * @param {function} cb
 * @returns {null}
 */
export const infiniteScroll = (ele, cb) => {
  const onScroll = () => {
    const scrollPos = window.scrollY + window.innerHeight;
    const scrollMax = ele.offsetHeight + ele.offsetTop;

    if (scrollPos >= scrollMax) cb();
  }

  window.addEventListener('scroll', onScroll);
}

/**
 * Get button html
 * 
 * @param {object} opts
 * @returns {string}
 */
export const buttonHtml = ({href, text, classes = '', target, download}) => {
  return `
    <a href="${href}" class="button${classes ? ` ${classes}` : ''}"${target ? ` target="${target}"` : ''}${download ? ' download' : ''}>
      <span class="button-bg"></span>
      <span class="button-text">${text}</span>
    </a>`;
}

/**
 * Download URL
 * 
 * @param {string} url
 * @param {string} filename
 * @returns {null}
 */
export const downloadUrl = (url, filename = '') => {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
}